// EU member states (27, as of 2026) — for VAT logic & VIES validation.
// Map between the country names used in src/libs/countries.js and ISO 3166-1 alpha-2 codes.
// VIES uses ISO codes EXCEPT Greece, which uses "EL" instead of "GR".

const EU_COUNTRIES = [
    { name: "Austria",                                  code: "AT", viesCode: "AT" },
    { name: "Belgium",                                  code: "BE", viesCode: "BE" },
    { name: "Bulgaria",                                 code: "BG", viesCode: "BG" },
    { name: "Croatia",                                  code: "HR", viesCode: "HR" },
    { name: "Cyprus",                                   code: "CY", viesCode: "CY" },
    { name: "Czechia",                                  code: "CZ", viesCode: "CZ" },
    { name: "Denmark",                                  code: "DK", viesCode: "DK" },
    { name: "Estonia",                                  code: "EE", viesCode: "EE" },
    { name: "Finland",                                  code: "FI", viesCode: "FI" },
    { name: "France",                                   code: "FR", viesCode: "FR" },
    { name: "Germany",                                  code: "DE", viesCode: "DE" },
    { name: "Greece",                                   code: "GR", viesCode: "EL" },
    { name: "Hungary",                                  code: "HU", viesCode: "HU" },
    { name: "Ireland",                                  code: "IE", viesCode: "IE" },
    { name: "Italy",                                    code: "IT", viesCode: "IT" },
    { name: "Latvia",                                   code: "LV", viesCode: "LV" },
    { name: "Lithuania",                                code: "LT", viesCode: "LT" },
    { name: "Luxembourg",                               code: "LU", viesCode: "LU" },
    { name: "Malta",                                    code: "MT", viesCode: "MT" },
    { name: "Netherlands (the)",                        code: "NL", viesCode: "NL" },
    { name: "Poland",                                   code: "PL", viesCode: "PL" },
    { name: "Portugal",                                 code: "PT", viesCode: "PT" },
    { name: "Romania",                                  code: "RO", viesCode: "RO" },
    { name: "Slovakia",                                 code: "SK", viesCode: "SK" },
    { name: "Slovenia",                                 code: "SI", viesCode: "SI" },
    { name: "Spain",                                    code: "ES", viesCode: "ES" },
    { name: "Sweden",                                   code: "SE", viesCode: "SE" },
];

const EU_NAMES = new Set(EU_COUNTRIES.map((c) => c.name));
const EU_BY_NAME = Object.fromEntries(EU_COUNTRIES.map((c) => [c.name, c]));

export function isEU(countryName) {
    return EU_NAMES.has(countryName);
}

export function euInfo(countryName) {
    return EU_BY_NAME[countryName] || null;
}

export default EU_COUNTRIES;
